<template>
  <div class="animated fadeIn">
    <b-card v-show="showList">
      <div slot="header">Supplier Purchase Price  
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <b-button variant="btn btn-primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="btn btn-primary mr-1" @click="deleteConfirm">Delete</b-button>
          <button class="btn btn-primary mr-1" @click="exportxls()">
              <i class="fa fa-file-excel-o"></i>
              Export
          </button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col  lg="4">
            <b-input-group >
              <b-input-group-prepend><span class="pt-2">Item </span></b-input-group-prepend>
              <b-form-input v-model="tblData.itemname" placeholder="Item Name" @change="itemChange"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuItemShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group>
        </b-col>
        <b-col lg="5">
          <b-input-group >
              <b-input-group-prepend><span class="p-2">Supplier</span></b-input-group-prepend>
              <b-form-input  v-model="tblData.vendor_name" @change="supplierChange"></b-form-input>
              <b-input-group-append>
              <b-btn text="Button" @click="lkuVendorShow=true" >
                  <i class="fa fa-search"></i>
              </b-btn>
              </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col  lg="3">
            <b-input-group >
                <b-input-group-append><b-button class="btn btn-success ml-3 mr-1" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button></b-input-group-append>
                <b-input-group-append><b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button></b-input-group-append>
            </b-input-group>
          </b-col>
        </b-row>                      

        <b-table
        class="mb-0"
            ref="tblVendor"
            responsive
            striped hover 
            style="font-size:smaller;"
            :items="data"
            :fields="fields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            :key="tblData.limit" 
            @row-clicked="selectItem"
          >
            <template v-slot:cell(unitprice)="data">
             <span v-if="(data.item.unitprice)">{{uanguser}} {{data.item.unitprice | numFormat}}</span>
            </template>
          <template v-slot:cell(action)="data">
            <div class="text-center">
            <a href="javascript:void(0)" @click="edit(data.item)">
              <i class="fa fa-pencil"></i>
            </a>
            |
            <a href="javascript:void(0)" class="text-danger" @click="deleteConfirm(data.item)">
              <i class="fa fa-trash"></i>
            </a>
            </div>
          </template>
          </b-table>
      <b-row>
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total | numFormat}} entries
          </div>
        </b-col>
        <b-col cols="2" >
          <b-input-group>
              <b-input-group-prepend><span class="pt-1 pr-2">Limit per page</span></b-input-group-prepend> 
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
          </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showFrm" header-bg-variant="primary" size="lg" title="Form - Supplier Purchase Price" :centered="true" @ok="save" ok-title="Save">
        <b-row >
          <b-col>
            <b-input-group >
              <b-input-group-prepend><label>Item Name</label></b-input-group-prepend>
              <b-form-input v-model="frmdata.itemname" placeholder="Item Name" :state="!$v.frmdata.itemno.$error"></b-form-input>
                <b-input-group-append>
                <b-btn text="Button" @click="lkuItemShow=true" >
                    <i class="fa fa-search"></i>
                </b-btn>
                </b-input-group-append>
            </b-input-group >
            <b-row>
              <b-col md="4">
                <b-input-group >
                  <b-input-group-prepend><label>Item Code</label></b-input-group-prepend>
                    <b-form-input v-model="frmdata.partnumber" disabled ></b-form-input>
                </b-input-group >
              </b-col>
              <b-col md="4">                            
                  <b-input-group >
                      <b-input-group-prepend><span class="p-2"> UnitSize</span></b-input-group-prepend>
                      <b-form-input v-model="frmdata.unitsize" disabled></b-form-input>
                  </b-input-group>
              </b-col>
            </b-row>
                  <b-input-group >
                    <b-input-group-prepend><label>Supplier</label></b-input-group-prepend>
                    <b-form-input  v-model="frmdata.vendorinfo" :state="!$v.frmdata.vendor_id.$error"></b-form-input>
                    <b-input-group-append>
                    <b-btn text="Button" @click="lkuVendorShow=true" >
                        <i class="fa fa-search"></i>
                    </b-btn>
                    </b-input-group-append>
                  </b-input-group >
            <b-row>
              <b-col md="8">
                  <b-input-group >
                      <b-input-group-prepend><label >Purchase Price</label></b-input-group-prepend>
                      <b-input-group-prepend>
                          <span class="input-group-text" style="width:60px;">{{uanguser}}</span>
                      </b-input-group-prepend>
                      <my-number class="form-control text-right" v-model="frmdata.unitprice" :precision="2" :state="!$v.frmdata.unitprice.$error"></my-number>
                  </b-input-group>
              </b-col>
            </b-row>

          </b-col>
      </b-row>
    </b-modal>

    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
    <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
      <p class="mb-1">1 record is about to be permanently deleted</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>
        <b-modal v-model="lkuVendorShow" size="lg" :hide-footer="true" title="List of Supplier" :centered="true">
            <lku-supplier @click="onSelectLkuVendor"></lku-supplier>
        </b-modal>        
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Master Item" :centered="true">
            <lku-item @click="onSelectLkuItem"  jasa="0" isactive="1" :formdata="itemList" ></lku-item>
        </b-modal>        

  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, decimal } from "vuelidate/lib/validators";
import item from "../../apis/bakerysupplierprice";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import myNumber from "../../components/my-number";
import lkuSupplier from "../lookup/lkuSupplier";
import lkuItem from "../lookup/lkuItemLazzy";
import toastr from "mini-toastr";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
        frmdata: {
            itemno: { required },
            unitprice: { required, decimal },
            vendor_id: { required },
        },
  },   
  data() {
    return {
      fields: [
          {
            key: "vendor_code",
            label: "Supplier Code",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "vendor_name",
            label: "Supplier",
            sortable: true
          },
          {
            key: "vendor_address",
            label: "Supplier Address",
          },
          {
            key: "itemname",
            label: "Item Name",
            sortable: true
          },
          {
            key: "partnumber",
            label: "Item Code (Master)",
            thStyle: "width:100px",
            sortable: true
          },
          {
            key: "unitsize",
            thStyle: "width:80px",
            label: "Order UnitSize",
            thClass: "text-center",
            tdClass: "text-center"
          },
          {
            key: "unitprice",
            tdClass: "text-right",
            label: "Purchase Price",
            thStyle: "width:100px",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        headcategory:null
      },
      items:[],
      model:{},showFrm:false,
      frmdata: {unitprice:0, itemno:'', vendor_id:''},
      lkuItemShow:false,
      itemList:{},
      lkuVendorShow:false,
        uanguser: this.$store.state.user.matauang,
      isLoading:false,
      showDelConfirm: false,
      showFilter:false,
      showList:true,
      showReport:false,
      reportUrl: `${location.origin}/#load`,
        activeStatus : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Discontinued' },{ value: '1', text: 'Active/In Use' }],
        jasaMaterial : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Material ' },{ value: '1', text: 'Service' }],
      headCategories:[], itemCategories:[]
    };
  },
  computed: {
    invalidFrmdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },  
  components :{Loading,lkuSupplier, lkuItem, myNumber},
  methods: {
    data: async function(ctx) {
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.itemlist) {
            this.tblData[key] = filter.itemlist[key];
            filtered=true;
        }
        if (filtered === true) {
          this.showFilter=filtered;
          delete filter.itemlist;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.lkuLoading = true;
      let list = await item.list(this.tblData);
      this.items=list;
      this.lkuLoading = false;
      return list;  
    },
    selectItem(record,index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    refresh() {
      this.$refs.tblVendor.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.itemno = '';
        this.tblData.itemname =  '';
        this.tblData.vendor_id = '';
        this.tblData.vendor_name =  '';
        this.refresh();
    },    
    itemChange: function () {
        this.tblData.itemno = '';
    },
    supplierChange: function () {
        this.tblData.vendor_id = '';
    },        
    add: function(data) {
          this.frmdata.vendor_id= '';
          this.frmdata.vendor_code= '';
          this.frmdata.vendor_name= '';
          this.frmdata.vendorinfo= '';
          this.frmdata.itemno= '';
          this.frmdata.itemcode= '';        
          this.frmdata.itemname= '';
          this.frmdata.partnumber= '';
          this.frmdata.tablekey= '';
          this.showFrm=true;
    },
    edit: function() {
        if (this.model) {
          this.frmdata.tablekey= this.model.tablekey;
          this.frmdata.vendor_id= this.model.vendor_id;
          this.frmdata.vendor_code= this.model.vendor_code;
          this.frmdata.vendor_name= this.model.vendor_name;
          this.frmdata.vendorinfo= `${this.model.vendor_code} | ${this.model.vendor_name}`;
          this.frmdata.itemno= this.model.itemno;
          this.frmdata.itemcode= this.model.itemcode;
          this.frmdata.itemname= this.model.itemname;
          this.frmdata.partnumber= this.model.partnumber;
          this.frmdata.unitsize= this.model.unitsize;
          this.frmdata.unitprice= this.model.unitprice;

          this.showFrm=true;
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    onSelectLkuItem: function (lkuData) {
        this.itemList=lkuData;
        this.lkuItemShow=false;
        this.tblData.itemno = lkuData.selected.itemno;
        this.tblData.itemname = lkuData.selected.itemname;
        this.frmdata.itemno = lkuData.selected.itemno;
        this.frmdata.itemname = lkuData.selected.itemname;
        this.frmdata.partnumber = lkuData.selected.partnumber;
        this.frmdata.unitsize = lkuData.selected.unitsize;
        this.frmdata.unitprice = lkuData.selected.unitprice;
    },
    onSelectLkuVendor: async function (_selected) {
        this.tblData.vendorinfo = _selected.vendor_code.trim() + ' | ' + _selected.vendor_name.trim();
        this.tblData.vendor = _selected.vendor_code;
        this.tblData.custcode = _selected.vendor_code;
        this.tblData.vendor_name = _selected.vendor_name;
        this.tblData.vendor_id = _selected.vendor_id;
        this.frmdata.vendor_id = _selected.vendor_id;
        this.frmdata.vendor = _selected.vendor_code;
        this.frmdata.vendor_name = _selected.vendor_name;
        this.frmdata.vendorinfo = _selected.vendor_code.trim() + ' | ' + _selected.vendor_name.trim();
        this.lkuVendorShow=false;
    },    
    save: async function(evt) {
      evt.preventDefault()
      if (this.invalidFrmdata) {
          console.log('validation : ', this.$v.frmdata);
          console.log('frmdata obj : ',this.frmdata);
          toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
      } else {
        try {
          this.showFrm = false;
          await item.save(this.frmdata);
          this.refresh();          
        } catch (error) {
          this.showFrm = true;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }            
        }
      }
  },
    deleteConfirm() {
        if (this.model) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await item.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.itemno==this.model.itemno));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },

    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await item.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message, 'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error), 'ERROR MESSAGE',10000);
            }
        }
    },
    closeFrm(){
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
